import IndexedDB from '@/lib/indexDB.js'
import http from '@/lib/request.js'
import CryptoJS from 'crypto-js'

class TranslateService {
  constructor() {
    this.db = new IndexedDB({
      dbName: 'HF_DATABASE',
      schema: {
        translate: {
          keyPath: 'key',
          indexes: ['value'],
        },
      },
    })
  }

  getCommonErrorTranslate(lang) {
    // 获取错误码翻译
    const dicSetKeySet = [
      'HCC.multilan.error.{lan}',
      'CCF.multilan.error.{lan}',
      'CCF.multilan.ezvizError.{lan}',
      'HF.multilan.error.{lan}',
    ]
    return this.getTranslate(dicSetKeySet, lang)
  }

  async getTranslate(dicSetKeySet, lang) {
    const translateFromDB = {}
    await this.db.open()
    // 先从indexDB数据库中获取
    const dicSetListPromise = dicSetKeySet.map(async (item) => {
      const dicSetKey = item.replace('{lan}', lang)
      const data = await this.getTranslateFromDBByKey(dicSetKey)
      if (data) {
        translateFromDB[dicSetKey] = data.translate
        return {
          dicSetKey: dicSetKey,
          updateTime: data.updateTime,
        }
      } else {
        return {
          dicSetKey: dicSetKey,
          updateTime: 0,
        }
      }
    })
    const dicSetList = await Promise.all(dicSetListPromise)
    const result = await this.getTranslateFromServer(dicSetList)
    if (result) {
      for (const { setKey, lastUpdateTime, dataInfos } of result.data.translateContentList) {
        const mergeTranslate = { ...translateFromDB[setKey], ...dataInfos }
        await this.db.set('translate', {
          key: setKey,
          translate: mergeTranslate,
          updateTime: lastUpdateTime,
        })
        translateFromDB[setKey] = mergeTranslate
      }
    }
    // 异步关闭即可
    this.db.close()
    return translateFromDB
  }

  async getTranslateFromServer(dicSetList) {
    const timestamp = Date.now()
    const accessToken = CryptoJS.SHA256('OJub68UJok#hf98JH@HI30jo' + timestamp).toString()
    return http.post('/ccfdic/translate/v2/getContentBySet', {
      accessToken,
      timestamp,
      dicSetList,
      businessId: 7, // HF
    })
  }

  async getTranslateFromDBByKey(key) {
    return this.db.get('translate', key)
  }
}

export default new TranslateService()
